import React from 'react'
import { useSelector } from 'react-redux'
import { Box, CircularProgress, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { formatDate } from './helpers'
import ThreadMessage from './ThreadMessage'

const ConversationThreadPanel = () => {
  const theme = useTheme()
  const { selectedConversationId, threads, threadLoading, threadError } = useSelector(
    state => state.chatbotConversations,
  )

  const thread = selectedConversationId ? threads[selectedConversationId] : null
  const isLoading = selectedConversationId ? threadLoading[selectedConversationId] : false
  const hasError = selectedConversationId ? threadError[selectedConversationId] : false

  if (!selectedConversationId) {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
          bgcolor: theme.palette.grey[50],
          borderLeft: `1px solid ${theme.palette.grey[200]}`,
        }}
      >
        <Typography variant='body2' color='textSecondary'>
          Select a conversation to view the thread
        </Typography>
      </Box>
    )
  }

  if (isLoading) {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
          bgcolor: theme.palette.grey[50],
          borderLeft: `1px solid ${theme.palette.grey[200]}`,
        }}
      >
        <CircularProgress size={32} />
      </Box>
    )
  }

  if (!thread) {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
          bgcolor: theme.palette.grey[50],
          borderLeft: `1px solid ${theme.palette.grey[200]}`,
        }}
      >
        <Typography variant='body2' color={hasError ? 'error' : 'textSecondary'}>
          {hasError ? 'Failed to load conversation' : 'No messages found'}
        </Typography>
      </Box>
    )
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        borderLeft: `1px solid ${theme.palette.grey[200]}`,
      }}
    >
      <Box
        sx={{
          p: 2,
          borderBottom: `1px solid ${theme.palette.grey[200]}`,
          bgcolor: theme.palette.background.paper,
          flexShrink: 0,
        }}
      >
        <Typography variant='subtitle2' noWrap>
          {thread.userEmail}
        </Typography>
        <Typography variant='caption' color='textSecondary' sx={{ display: 'block' }}>
          ID: {thread.conversationId}
        </Typography>
        <Typography variant='caption' color='textSecondary'>
          {formatDate(thread.firstMessageAt)} - {formatDate(thread.lastMessageAt)}
        </Typography>
      </Box>

      <Box sx={{ flex: 1, overflowY: 'auto', p: 2, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
        {(thread.messages ?? []).map(message => (
          <ThreadMessage key={message.id} message={message} />
        ))}
      </Box>
    </Box>
  )
}

export default ConversationThreadPanel
